module.exports = __webpack_public_path__ + "static/media/equifax-header.e242f03e.png";